var map = {
	"./admin_settings.png": 1706,
	"./catalog.png": 1707,
	"./catalogWhite.png": 1708,
	"./catalog_orders.png": 1709,
	"./cms.png": 1710,
	"./component-fields/Asset.png": 1711,
	"./component-fields/Blocks.png": 1712,
	"./component-fields/Boolean.png": 1713,
	"./component-fields/Date-time.png": 1714,
	"./component-fields/LInk.png": 1715,
	"./component-fields/Markdown.png": 1716,
	"./component-fields/Multi asset.png": 1717,
	"./component-fields/Multi options.png": 1718,
	"./component-fields/Number.png": 1719,
	"./component-fields/Richtext.png": 1720,
	"./component-fields/Single options.png": 1721,
	"./component-fields/Table.png": 1722,
	"./component-fields/Text area.png": 1723,
	"./component-fields/Text.png": 1724,
	"./components.png": 1725,
	"./configuration.png": 1726,
	"./contents.png": 1727,
	"./crm.png": 1728,
	"./custom_order.png": 1729,
	"./customer_credits.png": 1730,
	"./customer_list.png": 1731,
	"./dashboard.png": 1732,
	"./finance.png": 1733,
	"./home.png": 1734,
	"./integrations.png": 1735,
	"./inventory-transfers.png": 1736,
	"./invoice-list.png": 1737,
	"./layaway.png": 1738,
	"./move.png": 1739,
	"./new_sale.png": 1740,
	"./orders.png": 1741,
	"./outgoing-consignments.png": 1742,
	"./payment-methods/amex.png": 1113,
	"./payment-methods/discover.png": 1112,
	"./payment-methods/mastercard.png": 1111,
	"./payment-methods/visa.png": 1110,
	"./payments.png": 1743,
	"./register.png": 1744,
	"./repair_center.png": 1745,
	"./reports.png": 1746,
	"./services.png": 1747,
	"./trade_in_center.png": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;